import { ComponentType, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '../../common/ui/theme';

export interface CaptionProps {
    $negative?: boolean;
    Icon?: ComponentType<{ width?: number; height?: number }>;
    children: ReactNode;
}

const negativeStyles = css`
    color: ${theme.colors.negative.foreground};
`;

interface CaptionWrapperProps {
    $negative: boolean;
}

const CaptionWrapper = styled.span<CaptionWrapperProps>`
    display: flex;
    flex-direction: row;
    align-items: start;
    gap: 4px;
    color: ${theme.colors.foreground.subtle};
    font-size: 12px;
    font-weight: ${theme.fontWeights[400]};
    line-height: 16px;
    width: 100%;
    ${(p) => (p.$negative ? negativeStyles : null)};
`;

export const Caption = ({ children, $negative = false, Icon }: CaptionProps) => {
    return (
        <CaptionWrapper $negative={$negative}>
            {Icon ? <Icon height={16} width={16} /> : null}
            {children}
        </CaptionWrapper>
    );
};
